import { apiFetch } from "./client";

export interface StockyHistorySourceFile {
  sourceImportId: string;
  fileName: string;
  fileBase64: string;
}

export interface StockyHistoryImportResult {
  batch_id: string;
  dry_run: boolean;
  plan_token: string | null;
  file_count: number;
  total_bytes: number;
  source_rows: number;
  record_count: number;
  created: number;
  updated: number;
  unchanged: number;
  adopted_api: number;
  archived_files: number;
  normalization_mode: "domain" | "retention_only";
  normalized_rows: number;
  unprocessed_rows: number;
  domain_normalization_complete: boolean;
  detail_provided_records: number;
  detail_not_provided_records: number;
  detail_conflict_records: number;
  retention_reason:
    | "hard_row_cap_exceeded"
    | "hard_logical_record_cap_exceeded"
    | null;
}

interface HistoryRequest {
  batchId: string;
  files: readonly StockyHistorySourceFile[];
  planToken?: string;
  confirmRetentionOnly?: boolean;
}

function requestBody(request: HistoryRequest) {
  return {
    batch_id: request.batchId,
    files: request.files.map((file) => ({
      source_import_id: file.sourceImportId,
      file_name: file.fileName,
      file_base64: file.fileBase64,
    })),
    ...(request.planToken === undefined
      ? {}
      : { plan_token: request.planToken }),
    ...(request.confirmRetentionOnly === undefined
      ? {}
      : { confirm_retention_only: request.confirmRetentionOnly }),
  };
}

const HISTORY = "/api/migrate/csv/history";

export function dryRunPurchaseOrderHistory(
  request: HistoryRequest,
): Promise<StockyHistoryImportResult> {
  return apiFetch(`${HISTORY}/purchase-orders/dry-run`, {
    method: "POST",
    body: requestBody(request),
  });
}

export function applyPurchaseOrderHistory(
  request: HistoryRequest,
): Promise<StockyHistoryImportResult> {
  return apiFetch(`${HISTORY}/purchase-orders/apply`, {
    method: "POST",
    body: requestBody(request),
  });
}

export function dryRunStockAdjustmentHistory(
  request: HistoryRequest,
): Promise<StockyHistoryImportResult> {
  return apiFetch(`${HISTORY}/stock-adjustments/dry-run`, {
    method: "POST",
    body: requestBody(request),
  });
}

export function applyStockAdjustmentHistory(
  request: HistoryRequest,
): Promise<StockyHistoryImportResult> {
  return apiFetch(`${HISTORY}/stock-adjustments/apply`, {
    method: "POST",
    body: requestBody(request),
  });
}
